<template>

   <!-- XOL-371: request creation is open to any non-view-only Tower Co user; POST /actions has no API role gate -->
   <popup
    :button-style="scheme.colour"
    :heading="'Request to ' + scheme.text"
    :show-text="showText"
    :size="this.adding ? 'small' : 'default'"
    :button-type="buttonType"
    :button-text="scheme.text"
    :center-button="true"
    :round="round"
    :show-save="adding"
    :bg-class="formatBG"
    :button-icon="scheme.icon"
    :disableButton="isViewOnly() || rtbBlocked"
    @save="onSaveDialog"
    @close="onCloseDialog">

    <section v-if="type === 'RTA'">
        <el-row>
            <el-col :span="24">

              <acquire-request v-if="adding" ref="ad" :client-id="this.orgId" />

              <acquire-details v-else ref="ad" :row-data="rowData" />

            </el-col>
        </el-row>
      </section>

      <section v-else>

        <action-details
          v-if="adding"
          ref="ad"
          :site-id="siteId"
          :row-data="rowData"
          :editMode="true"
          :type="type"
          :adding="true"
          :hide-panel="true"
          :table-ref="tref" />

        <request-details v-else :row-data="rowData" />

      </section>

   </popup>

</template>


<script>

import AcquireRequest from '@/components/requests/acquire/AcquireRequest'

import AcquireDetails from '@/components/requests/acquire/AcquireDetails'
import ActionDetails from '@/components/actions/ActionDetails'

import RequestDetails from '@/components/requests/RequestDetails'

export default {

  name: 'RequestAction',

  components: {
    AcquireRequest,
    AcquireDetails,
    ActionDetails,
    RequestDetails
  },

  props: {

    showText: {
      type: Boolean,
      default: true
    },

    type: {
      type: String,
      default: 'RTS'
    },

    siteId: {
      type: Number,
      default: null
    },

    orgId: {
      type: Number,
      default: null
    },

    rowData: {
      type: Object,
      default: null
    },

    adding: {
      type: Boolean,
      default: true
    },

    buttonType: {
      type: String,
      default: null
    },

    round: {
      type: Boolean,
      default: false
    },

    tableRef: {
      type: String,
      default: '-action-table'
    }
  },



  computed: {
    formatBG: function() {
      let cls = null

      switch (this.type) {
        case 'RTA':
          cls = 'bg-warning-lighten-2'
          break

        case 'RTS':
          cls = 'bg-success-lighten-2'
          break

        case 'RTU':
          cls = 'bg-primary-lighten-1'
          break

        case 'RTB':
          cls = 'bg-info-lighten-2'
          break

        case 'RTD':
        cls =  'bg-danger-ligthen-2'
        break

      }

      return cls
    },

    rtbBlocked: function () {
      // Telco-only gate: orgs with canCreateRTB explicitly false cannot create
      // an RTB. Undefined is treated as enabled (tolerant of stale session
      // cache before the API column ships). Non-Telco users are unaffected.
      const o = this.org()
      return this.type === 'RTB' && this.isTelco() && o && o.canCreateRTB === false
    }

  },


  methods: {

    onSaveDialog () {

      if (this.$refs.ad) {
        this.$refs.ad.onSave()
      }

    },

    onCloseDialog () {

      if (this.$refs.ad) {
        this.$refs.ad.onClose()
      }
    }

  },

  data () {
    return {
      tref: this.type.toLowerCase() + this.tableRef,
      scheme: {
        text: 'Share',
        icon: 'fa fa-share-alt',
        colour: 'success'
      },
    }
  },

  created () {

    if (this.type === 'RTA') {
      this.scheme.text = 'Acquire'
      this.scheme.icon = 'fa fa-street-view'
      this.scheme.colour = 'warning'
    }

    if (this.type === 'RTU') {
      this.scheme.text = 'Upgrade'
      this.scheme.icon = 'fa fa-tools'
      this.scheme.colour = 'primary'
    }

    if (this.type === 'RTB') {
      this.scheme.text = 'Backhaul'
      this.scheme.icon = 'fa fa-wifi'
      this.scheme.colour = 'info'
    }

    if (this.type === 'RTD') {
      this.scheme.text = 'Dismantle'
      this.scheme.icon = 'fa fa-xmark'
      this.scheme.colour = 'danger'
    }



  }
}

</script>
